import { getAuthenticationUserId, getAuthenticationUserName } from 'data/authentication/authentication.selectors';
import { createCollectionFunctionGroupFromForm } from 'data/collectionFunctionGroup/collectionFunctionGroup.actions';
import { getCollectionFunctionGroupCreatedId, getCollectionFunctionGroupList } from 'data/collectionFunctionGroup/collectionFunctionGroup.selectors';
import { CollectionFunctionGroup } from 'data/collectionFunctionGroup/collectionFunctionGroup.types';
import { getSelectedDeliveryFunctionId } from 'global/global-selectors';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import getCollectionFunctionGroupDataToSubmit from 'routes/CollectionFunctionGroup/utils/getCollectionFunctionGroupDataToSubmit';
import { FieldUpdateHandlerParam } from 'shared/form';
import { isDiscoverySettingAuditEnabled } from 'xcipio/discovery-xcipio-selectors';
import { CollectionFunctionFormFieldHandler } from '../components/CollectionFunctionForm';

// eslint-disable-next-line import/prefer-default-export
export function useFieldCreateNewCollectionFunctionGroup(
  handleFieldUpdate: CollectionFunctionFormFieldHandler,
): [CollectionFunctionFormFieldHandler] {
  const deliveryFunctionId = useSelector(getSelectedDeliveryFunctionId);
  const isAuditEnabled = useSelector(isDiscoverySettingAuditEnabled);
  const userId = useSelector(getAuthenticationUserId);
  const userName = useSelector(getAuthenticationUserName);
  const collectionFunctionGroupList = useSelector(getCollectionFunctionGroupList);
  const createdId = useSelector(getCollectionFunctionGroupCreatedId);
  const dispatch = useDispatch();
  const paramRef = useRef<FieldUpdateHandlerParam>();

  useEffect(() => {
    if (createdId == null || paramRef.current == null) {
      return;
    }

    const createdCollectionFunctionGroup = collectionFunctionGroupList.find(({ id }) => id === createdId);
    if (createdCollectionFunctionGroup == null) {
      // The list is not up to date yet, so wait.
      return;
    }

    const param = paramRef.current;
    if (param == null) {
      return;
    }

    paramRef.current = undefined;

    param.value = createdId;

    handleFieldUpdate(param, 'main');

  }, [createdId, collectionFunctionGroupList]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFieldCreateNew: CollectionFunctionFormFieldHandler = (param) => {
    const collectionFunctionGroup: CollectionFunctionGroup = {
      id: '',
      name: param.valueLabel,
      description: '',
      cfs: [],
    };

    const body = getCollectionFunctionGroupDataToSubmit(
      collectionFunctionGroup,
      null,
      isAuditEnabled,
      userId,
      userName,
      'CREATE',
    );

    dispatch(createCollectionFunctionGroupFromForm(deliveryFunctionId, body));

    paramRef.current = param;
  };

  return [handleFieldCreateNew];
}
